module.exports = __webpack_public_path__ + "static/media/todo_secretary_logo.fefc4c91.png";